<template>
  <div class="recharge-search">
    <div class="search-header">
      <div class="search-input">
        <img src="@/assets/images/icon-back.png" @click="$router.go(-1)" alt="" />
        <van-search
          v-model="gameName"
          placeholder="搜索游戏名称"
          shape="round"
        />
      </div>
      <div class="search-btn" @click="onSearch">搜索</div>
    </div>

    <div class="container">
      <div class="search-not-found" v-if="searchEmpty">
        <span>没有找到你搜索的游戏</span>
        <span>请告诉我们你要找的游戏是什么？</span>
        <div class="feedback">反馈给我们</div>
      </div>

      <div class="search-game-list">
        <h1 class="title">{{ searchEmpty ? "大家都在玩" : "搜索结果" }}</h1>

        <div
          :class="['game-list-box', searchEmpty ? 'game-list-search-box' : '']"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="暂无更多数据"
            @load="onLoad"
          >
            <div class="game-list">
              <div
                class="game-item"
                v-for="info in gameList"
                :key="info.game_id"
                @click="getSearchGameInfo(info)"
              >
                <div class="game-item-content">
                  <img class="game-logo" :src="info.logo_url" alt="" />
                  <div class="game-info">
                    <div class="game-info-title">
                      <h1>{{ info.game_name }}</h1>
                      <span>{{ info.discount }}</span>
                    </div>
                    <div class="game-info-desc">
                      <div class="game-info-gift">
                        <span>福利</span>
                        <span>专属折扣</span>
                      </div>
                      <div class="star">
                        <img src="@/assets/images/star_all.png" alt="" />
                        <img src="@/assets/images/star_half.png" alt="" />
                      </div>
                    </div>
                    <div class="game-tag">
                      <span v-for="tag in info.gameType" :key="tag">{{
                        tag
                      }}</span>
                      <span class="other-tag">{{ info.openServerDate }}</span>
                    </div>
                  </div>
                </div>
                <div class="game-item-operate">
                  <!-- <span>充值</span>
                  <span>下载</span> -->
                  <img :src="info.platUrl" alt="" />
                  <span>{{ info.platName }}</span>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      gameName: "",
      gameList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchEmpty: false,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  methods: {
    onSearch() {
      this.searchEmpty = false;
      this.resetList(); // 重置数据
      this.onLoad(); // 重新加载第一页数据
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.gameList = []; // 清空当前列表
      this.totalCount = 0;
    },

    // 清空搜索条件并重新加载全部数据
    resetSearch() {
      this.gameName = ""; // 清空搜索关键词
      this.searchEmpty = true;
      this.resetList(); // 重置数据
      this.onLoad(); // 重新加载第一页数据
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.gameListQr();
      // 如果搜索结果为空并且有搜索关键词，清空搜索条件并重新加载全部数据
      if (this.gameName && data.length === 0) {
        this.resetSearch(); // 清空搜索条件并重新加载数据
        return;
      }
      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr(isSearch) {
      // debugger
      if (isSearch) {
        this.currentPage = 1;
        this.finished = false;
        this.gameList = [];
      }
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameName: this.gameName,
              location: "RECHARGE_SEARCH",
            }),
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    getSearchGameInfo(info) {
      const { game_id, game_name, platUrl, platName, discount, logo_url } = info
      this.$router.replace({ path: "/recharge", query: {
        gameName: game_name,
        platUrl,
        platName,
        discount,
        logoUrl: logo_url,
        gameId: game_id,
        rechargeGameId: game_id
      } });
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-search {
  background: #f4f4f4;
  height: 100vh;
  overflow: hidden;
  .search-header {
    padding: 24px 35px 24px 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 9999;
    background: #fff;

    .search-input {
      position: relative;
      width: 530px;
      display: flex;
      align-items: center;

      .van-search {
        padding: 0;
        width: 485px;
      }
      .van-search__content {
        background: #f4f4f4;
      }

      input {
        width: 485px;
        height: 60px;
        background: #f4f4f4;
        border-radius: 30px;
        border: none;
        padding: 0 60px;
      }
      img {
        width: 20px;
        height: 40px;
        margin-right: 20px;
      }
    }
    .search-btn {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ff7a3e;
      margin-right: 20px;
    }
  }
  .container {
    margin-top: 10px;

    .search-not-found {
      width: 100%;
      height: 250px;
      background: #fff;
      text-align: center;
      padding-top: 60px;

      span {
        display: block;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
        line-height: 36px;
      }
      .feedback {
        margin: 0 auto;
        width: 200px;
        height: 60px;
        background: #ff7a3e;
        border-radius: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-top: 20px;
      }
    }

    .search-game-list {
      margin-top: 30px;
      .title {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 36px;
        color: #000000;
        line-height: 36px;
        margin-left: 39px;
        margin-bottom: 24px;
      }

      .game-list-box {
        height: calc(100vh - 200px);
        overflow: auto;
      }
      .game-list-search-box {
        height: calc(100vh - 450px);
        // overflow: auto;
      }

      .game-list {
        padding: 0 40px;
        background: #fff;
        .game-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          //   margin-bottom: 30px;
          padding: 30px 0px;
          border-bottom: 1px solid #e6e6e6;
          &:last-child {
            margin-bottom: 0;
          }
        }

        .game-item-content {
          display: flex;
          align-items: center;

          .game-logo {
            width: 132px;
            height: 132px;
            margin-right: 20px;
          }
          .game-info {
            .game-info-title {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              h1 {
                max-width: 300px;
                font-weight: 600;
                font-size: 32px;
                color: #000000;
                line-height: 45px;
                margin-right: 6px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              span {
                display: block;
                padding: 5px 5px;
                font-weight: 600;
                font-size: 22px;
                color: #ffffff;
                height: 30px;
                background: #ff7a3e;
                border-radius: 4px;
              }
            }
            .game-info-desc {
              width: 280px;
              display: flex;
              align-items: center;
              margin-bottom: 20px;

              .game-info-gift {
                span {
                  padding: 4px 12px;
                  background: #f8f8f8;
                  border-radius: 4px;
                  border: 1px solid #f8f8f8;
                  font-weight: 500;
                  font-size: 18px;
                  color: #a2a2a2;
                  margin-right: 8px;
                }
              }
              .star {
                display: flex;
                align-items: center;
                img {
                  width: 24px;
                  margin-right: 8px;
                }
              }
            }
            .game-tag {
              span {
                padding: 2px 6px;
                // background: #f8f8f8;
                border-radius: 22px;
                border: 0px solid #d2d2d2;
                font-weight: 600;
                font-size: 20px;
                color: #a2a2a2;
                // margin-right: 18px;
              }
              .other-tag {
                color: #ffbe70;
              }
            }
          }
        }

        .game-item-operate {
          display: flex;
          align-items: center;
          width: 125px;
          height: 46px;
          border-radius: 23px 0 0 23px;
          background: #e6e6e6;
          padding-left: 6px;
          margin-right: -40px;
          img {
            width: 35px;
            height: 35px;
            margin-right: 8px;
            border-radius: 50%;
          }
          span {
            color: #ff7a3e;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/rechargeSearch/index.vue